import { render, staticRenderFns } from "./CompletarDatosModal.vue?vue&type=template&id=2825ef57"
import script from "./CompletarDatosModal.vue?vue&type=script&lang=js"
export * from "./CompletarDatosModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports